import React from 'react';

const AboutSection = () => {
  return (
    <section id="about" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1649424219467-4dd79e189be2?w=600"
                alt="Tribal Dash Dispensary"
                className="w-full h-[400px] object-cover"
              />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-neutral-900 mb-4 md:mb-6">
                About Tribal Dash
              </h2>
              <p className="text-base md:text-lg text-neutral-700 mb-4 md:mb-6 leading-relaxed">
                Tribal Dash Cannabis Delivery is proud to serve as the leading choice for cannabis enthusiasts in The Hamptons. Visit us at Cloud 9 on Montauk Highway in Southampton for exceptional products, outstanding customer service, and a welcoming atmosphere for all.
              </p>
              <p className="text-base md:text-lg text-neutral-700 leading-relaxed">
                Whether you're searching for delivery or pickup, Tribal Dash has you covered. From high-quality flower, concentrates, edibles, topicals, vapes, and more, we ensure our customers have access to the best in the industry.
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-neutral-50 to-neutral-100 rounded-2xl p-6 md:p-8 lg:p-12">
            <div className="max-w-3xl mx-auto text-center">
              <div className="inline-block p-3 md:p-4 bg-neutral-950 rounded-full mb-4 md:mb-6">
                <svg className="w-10 h-10 md:w-12 md:h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                </svg>
              </div>
              <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-neutral-900 mb-3 md:mb-4">Our Mission</h3>
              <p className="text-base md:text-lg text-neutral-700 leading-relaxed">
                Tribal Dash strives to provide customers in The Hamptons with quality products at competitive prices. Let our courteous and knowledgeable staff help you find the cannabis products to suit your needs. Browse our online menu and place an order for pick up or enjoy our convenient same-day delivery service.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
